import { render, staticRenderFns } from "./Copyable.vue?vue&type=template&id=05a08ada&"
import script from "./Copyable.vue?vue&type=script&lang=js&"
export * from "./Copyable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports